import { useTranslation } from "next-i18next";
import { size } from "../../../../../constants";
import { useWindowSize } from "../../../../../hooks/useWindowResize";
import { cn } from "../../../../../lib/utils";
import { Line } from "../../../casos/components/Line";
import { Subtitle } from "../../../casos/components/Subtitle";

function Result({ children, label }) {
	return (
		<div
			className={cn(
				"flex flex-col items-center w-full rounded-lg border-2 border-vivid-03 p-6",
				"laptop:w-[320px] laptop:h-[180px]",
			)}
		>
			<span
				className={cn(
					"font-bold text-[56px] leading-[72px] h-[64px] tracking-[-1.12px] text-vivid-03 mb-1 inline-block",
					"laptop:text-[60px] laptop:tracking-[-1.2px] laptop:h-[72px]",
				)}
			>
				{label}
			</span>

			{children}
		</div>
	);
}

export default function ResultsSection() {
	const { t } = useTranslation();
	const { width } = useWindowSize();
	const isMobile = width <= size.laptop;

	const squadIaBasePath = `/landings/assets/images/products/squad-ia`;

	const bgImagePath = `${squadIaBasePath}/squad-ia-resultados-verzel${
		isMobile ? "-mobile" : ""
	}.png`;

	return (
		<section className="relative flex flex-col-reverse overflow-hidden laptop:flex-row bg-background-02">
			<img
				src={bgImagePath}
				aria-hidden="true"
				className={cn(
					"z-0 w-full max-h-[392px] -mt-[90px] object-cover pointer-events-none select-none",
					"laptop:absolute laptop:top-0 laptop:left-0 laptop:w-[100%] laptop:h-full laptop:mt-0 laptop:max-h-none",
				)}
				alt=""
			/>

			<div className="w-full container-blog">
				<div className="relative z-10 flex max-w-[690px] flex-col items-center mx-auto laptopL:ml-auto laptopL:mx-0">
					<Line className="border-vivid-03" />

					<Subtitle className="text-center text-white mb-0 max-w-[302px] laptop:max-w-max">
						<h2>{t("products.squad-ia.results.title")}</h2>
					</Subtitle>

					<div
						className={cn(
							"grid grid-cols-1 gap-10 w-full laptop:max-w-[680px]",
							"mt-10",
							"laptop:mt-14 laptop:grid-cols-2",
						)}
					>
						<Result label="10x">
							<div
								className={cn(
									"laptop:text-xl w-[272px] font-semibold text-center text-white",
									"text-lg",
								)}
							>
								{t("products.squad-ia.results.metrics.speed")}
							</div>
						</Result>

						<Result label="-70%">
							<div
								className={cn(
									"laptop:text-xl laptop:max-w-[184px] max-w-[294px] font-semibold text-center text-white",
									"text-lg",
								)}
							>
								{t("products.squad-ia.results.metrics.costs")}
							</div>
						</Result>

						<Result label="100%">
							<div
								className={cn(
									"laptop:text-xl w-[272px] font-semibold text-center text-white",
									"text-lg",
								)}
							>
								{t("products.squad-ia.results.metrics.testCoverage")}
							</div>
						</Result>

						<Result label="100%">
							<div
								className={cn(
									"laptop:text-xl laptop:max-w-[184px] max-w-[294px] font-semibold text-center text-white",
									"text-lg",
								)}
							>
								{t("products.squad-ia.results.metrics.autonomousAgents")}
							</div>
						</Result>
					</div>
				</div>
			</div>
		</section>
	);
}
